<template>
  <div>
    <p :class="$style.forwardName">
      {{ $t('forwardFrom') }} {{ message.payload.name }}
    </p>
    <MessageContent
      :message="forwardedMessage"
    />
  </div>
</template>

<script>
import { TYPE_CODE } from '@/models/Message'

export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    forwardedMessage () {
      const message = { ...this.message.payload }
      if (message.type === TYPE_CODE.attachment) {
        message.attachment = this.message.attachment
      }
      message.properties = this.message.properties
      message.sender = this.message.sender
      return message
    }
  }
}
</script>
<style lang="scss" module>
.forwardName{
  padding-bottom: 5px;
  font-size: 14px;
}
</style>
